import colors from '../../../../../config/colors'
import { ColorVariant } from '../../components'
import { shortFormatNumber } from '../../util'

export function getColor(color: ColorVariant) {
  switch (color) {
    case ColorVariant.teal:
      return colors.teal[500]
    case ColorVariant.purple:
      return colors.purple[400]
    case ColorVariant.green:
      return colors.green[400]
    case ColorVariant.gray:
      return FinvizSettings.hasDarkTheme ? colors.gray[700] : colors.gray[200]
    default:
      return 'red'
  }
}
export function tickFormatter(value: any) {
  return shortFormatNumber(value, { fractions: Math.abs(value) >= 1_000 ? 0 : 2 })
}
